import { render } from "./QueryBuilder.vue?vue&type=template&id=23ac12f3"
import script from "./QueryBuilder.vue?vue&type=script&lang=js"
export * from "./QueryBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__